import Keycloak from 'keycloak-js'
import secureLocalStorage from 'react-secure-storage'

const isProdEnvironment = window.location.hostname === 'staff.ocplanet.cloud'

const keycloak = new Keycloak({
  url: (isProdEnvironment
    ? process.env.REACT_APP_KEYCLOAK_PROD_URL || 'https://auth.ocplanet.cloud/auth'
    : process.env.REACT_APP_KEYCLOAK_DEV_URL || 'https://auth.netengi.ua/auth').replace(/\/+$/, ''),
  realm: isProdEnvironment ? 'onecloud' : 'Onecloud',
  clientId: (isProdEnvironment ? process.env.REACT_APP_CLIENT_PROD : process.env.REACT_APP_CLIENT_DEV) || 'onecloud_main',
})

let initialization: Promise<boolean> | undefined

export const initializeKeycloak = (): Promise<boolean> => {
  if (!initialization) {
    localStorage.removeItem('cloud-jwt')
    secureLocalStorage.removeItem('userToken')
    secureLocalStorage.removeItem('userForTwoStep')

    keycloak.onTokenExpired = () => {
      void keycloak.updateToken(170).catch(() => {
        console.error('Keycloak token refresh failed')
      })
    }

    // Remove the fragment only from the return URI, leaving the actual callback
    // URL intact for the adapter to consume its authorization code.
    const redirectUri = new URL(window.location.href)
    redirectUri.hash = ''

    // Reuse this promise even on failure: an instance can only initialize once.
    initialization = keycloak.init({
      onLoad: 'login-required',
      checkLoginIframe: false,
      pkceMethod: 'S256',
      redirectUri: redirectUri.toString(),
    })
  }

  return initialization
}

export default keycloak
